import useSmallScreen from "../useSmallScreen";

import MeetingControlLargeScreen from "./MeetingControlLargeScreen";
import MeetingControlSmallScreen from "./MeetingControlSmallScreen";
function MeetingControls({
  fullScreen,
  setShowChat,
  setShowFloatingParticipants,
  ...props
}) {
  const [smallScreen] = useSmallScreen();
  return smallScreen ? (
    <MeetingControlSmallScreen
      fullScreen={fullScreen}
      setShowChat={setShowChat}
      setShowFloatingParticipants={setShowFloatingParticipants}
      {...props}
    />
  ) : (
    <MeetingControlLargeScreen
      fullScreen={fullScreen}
      setShowChat={setShowChat}
      setShowFloatingParticipants={setShowFloatingParticipants}
      {...props}
    />
  );
}

export default MeetingControls;
